module.exports = __webpack_public_path__ + "img/frame4.46f1151f.jpg";